import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';

export default {
  goalAmount: validateNumber({
    gt: 0,
    integer: true,
    allowBlank: false,
    message: 'Must be a positive whole number',
  }),
  startDate: validatePresence({ presence: true, message: "Can't be blank" }),
};
